"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HamianConfig {
    constructor(data = {}) {
        this.appId = '';
        this.serverUrl = '';
        this.botName = '';
        this.useChainId = false;
        this.appTitle = '';
        Object.assign(this, data);
        if (!this.serverUrl)
            this.serverUrl = 'http://hamian.areaxapp.com/';
        if (!this.botName)
            this.botName = 'hamianwalletbot';
    }
}
exports.default = HamianConfig;
